<div class="container" theme [styleObj]='brandStyleTheme'>

  <div class="row">
    <div class="col-12 col-md-4">
      <div class="card">

        <div class="card-header">

          <ng-template headerSection></ng-template>

        </div>

        @if(!isComponentReady) {

          <div class="loading-wrapper" role="status" aria-label="Loading">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          </div> 

        } @else {

          <form (ngSubmit)="onSubmit()" [formGroup]="form">

            <div class="card-body">

              @for (formField of formFields; track formField) {
                <div class="mb-2">
                  <app-form-field [formField]="formField" [form]="form" (emitCheckedEvent)="changePreference($event)"></app-form-field>
                </div>
              }

              <div class="row justify-content-center">
                <div class="col-auto text-center">

                  <button type="submit" icon="fa fa-check" class="wp-btn wp-btn-submit" [disabled]="!form.valid">Submit</button>
                  <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Cancel</button>

                </div>
              </div>

              @if (isSuccessMessageShown) {
                <div class="alert alert-success" role="alert">{{successMessage}}</div>
              }
              @if (isErrorMessageShown) {
                <div class="alert alert-danger" role="alert">{{errorMessage}}</div>
              }

            </div>

            <div class="card-footer">

              <ng-template footerSection></ng-template>

            </div>

          </form>

        }

      </div>
    </div>
  </div>

</div>

